import { IDicList } from "@models/dictionary/dic-base";

export enum UserPermissions {
  // Модуль "Администрирование"
  AdministrationUsersView = "AdministrationUsersView",
  AdministrationUsersAdd = "AdministrationUsersAdd",
  AdministrationUsersEdit = "AdministrationUsersEdit",
  AdministrationUsersDelete = "AdministrationUsersDelete",
  AdministrationRolesView = "AdministrationRolesView",
  AdministrationRolesAdd = "AdministrationRolesAdd",
  AdministrationRolesEdit = "AdministrationRolesEdit",
  AdministrationRolesDelete = "AdministrationRolesDelete",
  AdministrationAppPermissionsView = "AdministrationAppPermissionsView",
  AdministrationAppModulesView = "AdministrationAppModulesView",
  AdministrationMenusView = "AdministrationMenusView",
  AdministrationMenusAdd = "AdministrationMenusAdd",
  AdministrationMenusEdit = "AdministrationMenusEdit",
  AdministrationMenusDelete = "AdministrationMenusDelete",
  AdministrationMenuItemsView = "AdministrationMenuItemsView",
  AdministrationMenuItemsAdd = "AdministrationMenuItemsAdd",
  AdministrationMenuItemsEdit = "AdministrationMenuItemsEdit",
  AdministrationMenuItemsDelete = "AdministrationMenuItemsDelete",
  AdministrationGridsView = "AdministrationGridsView",
  AdministrationGridsEdit = "AdministrationGridsEdit",
  EventEventProfilesView = "EventEventProfilesView",
  EventEventProfilesEdit = "EventEventProfilesEdit",
  EventEventProfilesAdd = "EventEventProfilesAdd",
  EventEventHistoriesView = "EventEventHistoriesView",
  EventEventHistoriesEdit = "EventEventHistoriesEdit",
  ViewTagGroupList = "ViewTagGroupList",
  ViewTagGroupById = "ViewTagGroupById",
  EditTagGroupById = "EditTagGroupById",
  CreateTagGroup = "CreateTagGroup",
  DeleteTagGroupById = "DeleteTagGroupById",
  ViewTagList = "ViewTagList",
  ViewTagById = "ViewTagById",
  EditTagById = "EditTagById",
  CreateTag = "CreateTag",
  DeleteTagById = "DeleteTagById",
  // Модуль "Управление ресурсами"
  ResourceManagementPersonnelsView = "ResourceManagementPersonnelsView",
  ResourceManagementPersonnelsAdd = "ResourceManagementPersonnelsAdd",
  ResourceManagementPersonnelsEdit = "ResourceManagementPersonnelsEdit",
  ResourceManagementPersonnelsDelete = "ResourceManagementPersonnelsDelete",
  ResourceManagementStructuralUnitsView = "ResourceManagementStructuralUnitsView",
  ResourceManagementStructuralUnitsAdd = "ResourceManagementStructuralUnitsAdd",
  ResourceManagementStructuralUnitsEdit = "ResourceManagementStructuralUnitsEdit",
  ResourceManagementStructuralUnitsDelete = "ResourceManagementStructuralUnitsDelete",
  ResourceManagementOrganizationsView = "ResourceManagementOrganizationsView",
  ResourceManagementOrganizationsAdd = "ResourceManagementOrganizationsAdd",
  ResourceManagementOrganizationsEdit = "ResourceManagementOrganizationsEdit",
  ResourceManagementOrganizationsDelete = "ResourceManagementOrganizationsDelete",
  ResourceManagementPositionsView = "ResourceManagementPositionsView",
  ResourceManagementPositionsAdd = "ResourceManagementPositionsAdd",
  ResourceManagementPositionsEdit = "ResourceManagementPositionsEdit",
  ResourceManagementPositionsDelete = "ResourceManagementPositionsDelete",
  ResourceManagementTrackersView = "ResourceManagementTrackersView",
  ResourceManagementTrackersAdd = "ResourceManagementTrackersAdd",
  ResourceManagementTrackersEdit = "ResourceManagementTrackersEdit",
  ResourceManagementTrackersDelete = "ResourceManagementTrackersDelete",
  ResourceManagementTrackerAttachmentsView = "ResourceManagementTrackerAttachmentsView",
  ResourceManagementTrackerAttachmentsAdd = "ResourceManagementTrackerAttachmentsAdd",
  ResourceManagementTrackerAttachmentsEdit = "ResourceManagementTrackerAttachmentsEdit",
  ResourceManagementDevicesView = "ResourceManagementDevicesView",
  ResourceManagementLampTabNumberView = "ResourceManagementLampTabNumberView",
  ResourceManagementGasAnalyzerTabNumberView = "ResourceManagementGasAnalyzerTabNumberView",
  ResourceManagementWalkieTalkieTabNumberView = "ResourceManagementWalkieTalkieTabNumberView",
  ResourceManagementPhoneTabNumberView = "ResourceManagementPhoneTabNumberView",
  ResourceManagementCardTabNumberView = "ResourceManagementCardTabNumberView",
  ResourceManagementIssuanceDevicesAdd = "ResourceManagementIssuanceDevicesAdd",
  ResourceManagementAccessStatusView = "ResourceManagementAccessStatusView",
  ResourceManagementLampsView = "ResourceManagementLampsView",
  ResourceManagementGasAnalyzersView = "ResourceManagementGasAnalyzersView",
  ResourceManagementWalkieTalkiesView = "ResourceManagementWalkieTalkiesView",
  ResourceManagementPhonesView = "ResourceManagementPhonesView",
  ResourceManagementDevicesPossiblyFaultyView = "ResourceManagementDevicesPossiblyFaultyView",
  ResourceManagementDeviceRepairView = "ResourceManagementDeviceRepairView",
  ResourceManagementMineExitEntryView = "ResourceManagementMineExitEntryView",
  ResourceManagementIssuanceStatusView = "ResourceManagementIssuanceStatusView",
  ResourceManagementGateChecksEdit = "ResourceManagementGateChecksEdit",
  ResourceManagementIssuanceJournalAcceptButtonUse = "ResourceManagementIssuanceJournalAcceptButtonUse",
  // Модуль "Позиционирование персонала и транспорта"
  PositioningInteractiveMapLayersView = "PositioningInteractiveMapLayersView",
  PositioningInteractiveMapLayersAdd = "PositioningInteractiveMapLayersAdd",
  PositioningInteractiveMapLayersEdit = "PositioningInteractiveMapLayersEdit",
  PositioningInteractiveMapLayersDelete = "PositioningInteractiveMapLayersDelete",
  PositioningInteractiveMapObjectView = "PositioningInteractiveMapObjectView",
  PositioningInteractiveMapObjectAdd = "PositioningInteractiveMapObjectAdd",
  PositioningInteractiveMapObjectEdit = "PositioningInteractiveMapObjectEdit",
  PositioningInteractiveMapObjectDelete = "PositioningInteractiveMapObjectDelete",
  PositioningInteractiveMapViewLayersView = "PositioningInteractiveMapViewLayersView",
  PositioningInteractiveMapViewLayersAdd = "PositioningInteractiveMapViewLayersAdd",
  PositioningInteractiveMapViewLayersEdit = "PositioningInteractiveMapViewLayersEdit",
  PositioningInteractiveMapViewLayersDelete = "PositioningInteractiveMapViewLayersDelete",
  PositioningInteractiveMapViewObjectsView = "PositioningInteractiveMapViewObjectsView",
  PositioningInteractiveMapViewObjectsAdd = "PositioningInteractiveMapViewObjectsAdd",
  PositioningInteractiveMapViewObjectsEdit = "PositioningInteractiveMapViewObjectsEdit",
  PositioningInteractiveMapViewObjectsDelete = "PositioningInteractiveMapViewObjectsDelete",
  PositioningInteractiveMapViewsView = "PositioningInteractiveMapViewsView",
  PositioningInteractiveMapViewsAdd = "PositioningInteractiveMapViewsAdd",
  PositioningInteractiveMapViewsEdit = "PositioningInteractiveMapViewsEdit",
  PositioningInteractiveMapViewsDelete = "PositioningInteractiveMapViewsDelete",
  PositioningInteractiveMapsAdd = "PositioningInteractiveMapsAdd",
  PositioningInteractiveMapsView = "PositioningInteractiveMapsView",
  PositioningInteractiveMapsEdit = "PositioningInteractiveMapsEdit",
  PositioningInteractiveMapsDelete = "PositioningInteractiveMapsDelete",
  PositioningMapLayerObjectsView = "PositioningMapLayerObjectsView",
  NotificationView = "NotificationView",
  NotificationEdit = "NotificationEdit",
  AuditLogAccess = "AuditLogAccess",
  HealthMonitoringBreathalyzersEdit = "HealthMonitoringBreathalyzersEdit",
  HealthMonitoringTurnstilesEdit = "HealthMonitoringTurnstilesEdit",
  HealthMonitoringMedicalExaminationsView = "HealthMonitoringMedicalExaminationsView",
  ResourceManagementGateChecksView = "ResourceManagementGateChecksView",
  // Модуль "План-график"
  PlanWorkTypesView = "PlanWorkTypesView",
  PlanWorkTypesEdit = "PlanWorkTypesEdit",
  TargetTypesView = "TargetTypesView",
  TargetTypesEdit = "TargetTypesEdit",
  // Модуль "Наряд задания"
  FactSourcesView = "FactSourcesView",
  FactSourcesEdit = "FactSourcesEdit",
  WorkPlacesView = "WorkPlacesView",
  WorkPlacesEdit = "WorkPlacesEdit",
  WorkPlaceTypesView = "WorkPlaceTypesView",
  WorkPlaceTypesEdit = "WorkPlaceTypesEdit",
  WorkTypesView = "WorkTypesView",
  WorkTypesEdit = "WorkTypesEdit",
  WorkTasksView = "WorkTasksView",
  WorkTasksEdit = "WorkTasksEdit",
  ResourceManagementGateAccessAdd = "ResourceManagementGateAccessAdd",
  // Модуль "Аварийное оповещение (eahec)"
  EmergencyAlertView = "EmergencyAlertView",
  EmergencyAlertWrite = "EmergencyAlertWrite",
  TestTagView = "TestTagView",
  // Модуль "Мониторинг транспорта"
  EquipmentMonitorTransportDowntimeView = "EquipmentMonitorTransportDowntimeView",
  EquipmentMonitorTransportDowntimeEdit = "EquipmentMonitorTransportDowntimeEdit",
  EquipmentMonitorWorktimeLogGroupsView = "EquipmentMonitorWorktimeLogGroupsView",
  EquipmentMonitorWorktimeLogView = "EquipmentMonitorWorktimeLogView",
  EquipmentMonitorWorktimeLogEdit = "EquipmentMonitorWorktimeLogEdit",
  EquipmentMonitorEquipmentIndicatorsView = "EquipmentMonitorEquipmentIndicatorsView",
  EquipmentMonitorEquipmentIndicatorsEdit = "EquipmentMonitorEquipmentIndicatorsEdit",
  EquipmentMonitorRawDataView = "EquipmentMonitorRawDataView",
  EquipmentMonitorProcessedDataView = "EquipmentMonitorProcessedDataView",
  ResourceManagementEquipmentGroupsView = "ResourceManagementEquipmentGroupsView",
  EquipmentMonitoringEquipmentInfoView = "EquipmentMonitoringEquipmentInfoView",
  EquipmentMonitoringHaulPreviewView = "EquipmentMonitoringHaulPreviewView",
  // Модуль "Управление запасами"
  StoragesEdit = "StoragesEdit",
  StoragesView = "StoragesView",
  StorageMappingsView = "StorageMappingsView",
  StorageMappingsEdit = "StorageMappingsEdit",
  StorageConstraintView = "StorageConstraintView",
  StorageConstraintEdit = "StorageConstraintEdit",
  // Модуль "Лабораторный анализ"
  AnalysisView = "AnalysisView",
  AnalysisEdit = "AnalysisEdit",
  ChemicalElementsEdit = "ChemicalElementsEdit",
  ChemicalElementsView = "ChemicalElementsView",
  // Модуль "Шихтование"
  OreMixtureView = "OreMixtureView",
  OreMixtureEdit = "OreMixtureEdit",
  OreMixtureDelete = "OreMixtureDelete",
  // Модуль "Контактный график"
  MixtureCalculationTripSequenceView = "MixtureCalculationTripSequenceView",
  MixtureCalculationTripSequenceEdit = "MixtureCalculationTripSequenceEdit",
  // Список взвешиваний
  EquipmentMonitorWeighingView = "EquipmentMonitorWeighingView",
  EquipmentMonitorWeighingEdit = "EquipmentMonitorWeighingEdit",
  // Модуль "Контроль Доступа"
  AccessControlSeederSync = "AccessControlSeederSync",
  AccessControlWorkScheduleEdit = "AccessControlWorkScheduleEdit",
  AccessControlSchedulesView = "AccessControlSchedulesView",
  // Модуль "Месторождение"
  DictionaryOreDepositView = "DictionaryOreDepositView",
  DictionaryOreDepositEdit = "DictionaryOreDepositEdit",
  // Модуль "Конфигурация взвешивания транспорта"
  DictionaryEquipmentWeighingConfigView = "DictionaryEquipmentWeighingConfigView",
  DictionaryEquipmentWeighingConfigEdit = "DictionaryEquipmentWeighingConfigEdit",
  // Модуль КИТ/КТГ
  DictionaryTransportEfficiencyView = "DictionaryTransportEfficiencyView",
  // Модуль Шаблоны индикаторов
  DictionaryIndicatorTemplatesView = "DictionaryIndicatorTemplatesView",
  DictionaryIndicatorTemplatesEdit = "DictionaryIndicatorTemplatesEdit",
  // Отчет по заправкам
  DictionaryFuelReportView = "DictionaryFuelReportView",
  DictionaryFuelReportEdit = "DictionaryFuelReportEdit",
  // Модуль Архивирования
  ArchivingArchiveJobsView = "ArchivingArchiveJobsView",
  ArchivingArchiveJobsDownload = "ArchivingArchiveJobsDownload",
  ArchivingArchivePoliciesEdit = "ArchivingArchivePoliciesEdit",
  ArchivingArchivePoliciesDelete = "ArchivingArchivePoliciesDelete",
  ArchivingArchivePoliciesAdd = "ArchivingArchivePoliciesAdd",
  ArchivingArchivePoliciesView = "ArchivingArchivePoliciesView",
  // Модуль "Ламповой и Контроля доступа"
  LampVersionOne = "LampVersionOne",
  LampVersionTwo = "LampVersionTwo",
  // Сырые данные позиционирования
  PositioningHistoricalDataView = "PositioningHistoricalDataView",
  // HelpDesk
  HelpDeskEditView = "HelpDeskEditView",
}

export interface ICurrentUser {
  id: string;
  login: string | undefined;
  name: string | undefined;
  permissionCodes: UserPermissions[];
  roleNames: string[];
  photoPath?: string;
  accessToken?: string;
  refreshToken?: string;
  password?: string;
  homePageMenuItemUrl?: string;
}

export interface IEditUser {
  id: string;
  email: string;
  fullName: string;
  login: string;
  password: string;
}

export interface IAppUser {
  id: string;
  badgeNo: string;
  fullName: string;
  email: string;
  jobTitle: string;
  department: string;
  isActive: boolean;
  createdAt: string;
  supervisorShortModel: IAppUserSupervisorModel | null;
  pswsSupervisorShortModel: IAppUserSupervisorModel | null;
}

export interface IAppUserSupervisorModel {
  id: string;
  badgeNo: string;
  fullName: string;
}

export interface IBpUser {
  id: string;
  businessPartner: IDicList;
  fullName: string;
  email: string;
  jobTitle: string;
  isActive: boolean;
  createdAt: string;
  businessPartnerId?: string;
}
